import { createReduxModule } from "hooks-for-redux";

const defaultClientState = {
  profile: {},
};

export const [useClient, { setClient }] = createReduxModule("client", defaultClientState, {
  setClient: (state, data = {}) => {
    return {
      ...state,
      ...data,
    };
  },
});
